"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateBasicActivity = exports.generateActivityData = exports.generateExampleActivity = void 0;
const en_1 = require("@faker-js/faker/locale/en");
const tools_1 = require("../tools");
const activities_1 = require("./../types/activities");
const customFields_1 = require("./../types/customFields");
const questionnaire_1 = require("./questionnaire");
const workflows_1 = require("./workflows");
const generateExampleActivity = (activityId, customersListId) => {
    return {
        id: activityId,
        name: "activity name",
        active: true,
        version: 0,
        report_title_template: "Report title",
        updated_at: new Date(),
        updated_by: "_",
        questionnaire: (0, workflows_1.generateComplexQuestionnaire)(customersListId),
        report_prerequisite: activities_1.REPORT_PREREQUISITE.NO_NEED,
    };
};
exports.generateExampleActivity = generateExampleActivity;
const generateActivityData = (activity = {}) => {
    var _a, _b, _c, _d, _e, _f;
    return {
        id: activity.id || (0, tools_1.IDSource)(),
        name: activity.name || en_1.faker.word.words(2),
        active: (_a = activity.active) !== null && _a !== void 0 ? _a : true,
        questionnaire: (_b = activity.questionnaire) !== null && _b !== void 0 ? _b : (0, questionnaire_1.generateQuestionnaireData)(),
        version: (_c = activity.version) !== null && _c !== void 0 ? _c : 0,
        report_title_template: (_d = activity.report_title_template) !== null && _d !== void 0 ? _d : "Report title",
        updated_at: (_e = activity.updated_at) !== null && _e !== void 0 ? _e : new Date(),
        updated_by: (_f = activity.updated_by) !== null && _f !== void 0 ? _f : "_",
        report_prerequisite: activities_1.REPORT_PREREQUISITE.NEED_ONLY_CUSTOMER,
    };
};
exports.generateActivityData = generateActivityData;
const generateBasicActivity = (activityId) => {
    return {
        id: activityId,
        active: true,
        name: "activity name",
        report_prerequisite: activities_1.REPORT_PREREQUISITE.NO_NEED,
        updated_at: new Date(),
        updated_by: "",
        version: 0,
        questionnaire: {
            questions: [
                {
                    type: customFields_1.CUSTOM_FIELD_TYPE.TEXT,
                    answer_text: "",
                    tag: "name",
                    question_text: "What is your name?",
                    description: ".",
                    default_value: "Fullname",
                    required: false,
                    number_of_options: -1,
                    column_type: "string",
                },
            ],
        },
    };
};
exports.generateBasicActivity = generateBasicActivity;
